import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, RefreshCw, X, ExternalLink } from 'lucide-react';

export default function EmailQueueList({ items, tab, onRetry, onDismiss, colors }) {
  if (items.length === 0) {
    return (
      <div className="rounded-xl border p-10 text-center"
        style={{ backgroundColor: colors.surface, borderColor: colors.border }}>
        <Mail size={32} className="mx-auto mb-3" color={colors.textMuted} />
        <p className="text-sm" style={{ color: colors.textMuted }}>
          {tab === 'failed' ? 'No failed emails · nice work.' : `No emails in "${tab}".`}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((it) => (
        <div key={it.id} data-testid={`inbox-row-${it.id}`}
          className="rounded-xl border p-4 space-y-2"
          style={{ backgroundColor: colors.surface, borderColor: colors.border }}>
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="font-semibold truncate" style={{ color: colors.text }}>
                {it.from_email || '(unknown sender)'}
              </div>
              <div className="text-sm truncate" style={{ color: colors.textMuted }}>
                {it.subject || '(no subject)'}
              </div>
            </div>
            <span className="px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide"
              style={{
                backgroundColor: it.status === 'failed' ? colors.errorSoft
                  : it.status === 'succeeded' ? colors.accentSoft
                  : it.status === 'processing' ? colors.accentSoft
                  : colors.warningSoft,
                color: it.status === 'failed' ? colors.error
                  : it.status === 'succeeded' ? colors.accent
                  : colors.text,
              }}>
              {it.status}
            </span>
          </div>
          {it.reason ? (
            <div className="text-xs" style={{ color: colors.error }}>Reason: {it.reason}</div>
          ) : null}
          {it.linked_receipt_id ? (
            <Link to={`/receipts/${it.linked_receipt_id}`}
              data-testid={`open-receipt-${it.id}`}
              className="inline-flex items-center gap-1 text-xs font-semibold"
              style={{ color: colors.accent }}>
              <ExternalLink size={12} /> View extracted receipt
            </Link>
          ) : null}
          <div className="flex gap-3 pt-1">
            {it.status !== 'succeeded' && it.status !== 'processing' ? (
              <button data-testid={`retry-btn-${it.id}`} onClick={() => onRetry(it.id)}
                className="inline-flex items-center gap-1 text-xs font-semibold"
                style={{ color: colors.accent }}>
                <RefreshCw size={12} /> Retry
              </button>
            ) : null}
            <button data-testid={`dismiss-btn-${it.id}`} onClick={() => onDismiss(it.id)}
              className="inline-flex items-center gap-1 text-xs font-semibold"
              style={{ color: colors.textMuted }}>
              <X size={12} /> Dismiss
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
